
import * as types from '../../../../../../lib/actionTypes.es6'

export const getAllAcessBankCustomerPremiumsRequest = (payload) =>{
  return{
    type: types.GET_ALL_ACCESSBANK_CUSTOMER_PREMIUMS_REQUEST,
    payload,
  }
}

export const getAllAccessBankPremiumsSuccess = (payload) =>{
  return{
    type: types.GET_ALL_ACCESSBANK_CUSTOMER_PREMIUMS_SUCCESS,
    payload: payload,
  }
}
export const getAllAccessBankPremiumsFailure = (error) =>{
  return{
    type: types.GET_ALL_ACCESSBANK_CUSTOMER_PREMIUMS_FAILURE,
    payload: error,
  }
}

export const removeComplexPremiumRequest = (payload) => ({
  type: types.REMOVE_COMPLEX_PREMIUM_REQUEST,
  payload,
})

export const removeComplexPremiumSuccess = (payload) => ({
  type: types.REMOVE_COMPLEX_PREMIUM_SUCCESS,
  payload,
})

export const removeComplexPremiumFailure = (error) => ({
  type: types.REMOVE_COMPLEX_PREMIUM_FAILURE,
  payload: error,
})

export const resetRemoveComplexPremiumSuccess = () => ({
  type: types.RESET_REMOVE_COMPLEX_PREMIUM_SUCCESS,
})

export const resetRemoveComplexPremiumError = () => ({
  type: types.RESET_REMOVE_COMPLEX_PREMIUM_ERROR,
})

export const setPremiumToRemove = (payload) => ({
  type: types.SET_PREMIUM_TO_REMOVE,
  payload,
})

export const resetPremiumToRemove = () => ({
  type: types.RESET_PREMIUM_TO_REMOVE,
})